/**
 * 애플리케이션 전역 상수
 *
 * 환경 변수가 아닌 코드 레벨의 상수를 정의합니다.
 */

/**
 * Google Sheets API 관련 상수
 */
export const GOOGLE_SHEETS = {
  // OAuth 범위
  SCOPES: [
    'https://www.googleapis.com/auth/spreadsheets',
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile',
  ],

  // API 버전
  API_VERSION: 'v4',

  // Rate Limiting
  MAX_REQUESTS_PER_MINUTE: 100,
  MAX_BATCH_SIZE: 100,
} as const

/**
 * 시트 이름 (Google Spreadsheet 내부)
 */
export const SHEET_NAMES = {
  README: 'README', // 워크스페이스 정보 및 경고문 표시 (첫 번째 시트)
  TRANSACTIONS: 'Transactions',
  CATEGORIES: 'Categories',
  PAYMENT_METHODS: 'PaymentMethods',
  USERS: 'Users',
  BUDGETS: 'Budgets',
} as const

/**
 * 로컬 스토리지 키
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'ourwallet_auth_token',
  USER_INFO: 'ourwallet_user_info',
  LAST_SYNC: 'ourwallet_last_sync',

  // UI 환경설정 (페이지/컴포넌트 prefs)
  TRANSACTION_SUMMARY_EXPANDED: 'transaction-summary-expanded',
  // 거래 표시 모드 (compact/full) — TransactionDisplayMode.ts 와 동기화 필요
  TRANSACTION_DISPLAY_MODE: 'transaction-display-mode',

  // 거래 일괄 입력 작성 중 내용 (A-7)
  // @why 다건을 몰아서 입력하는 화면이라 실수로 나가거나 새로고침하면 손실이 크다.
  //      워크스페이스마다 카테고리/결제수단/멤버가 달라 드래프트를 섞으면 안 되므로
  //      실제 키는 이 접두사 뒤에 워크스페이스 ID를 붙여 쓴다.
  BULK_TRANSACTION_DRAFT_PREFIX: 'ourwallet_bulk_transaction_draft',

  // 개발/Mock 모드 (env.ts 와 동기화)
  USE_MOCK_DATA: 'USE_MOCK_DATA',
  // 레거시 user-info 키 (env.ts에서 마이그레이션 시 정리 대상)
  LEGACY_USER_INFO: 'user-info',
} as const

/**
 * 날짜 포맷
 */
export const DATE_FORMATS = {
  DISPLAY: 'yyyy-MM-dd',
  API: 'yyyy-MM-dd',
  DATETIME: "yyyy-MM-dd'T'HH:mm:ss'Z'",
} as const

/**
 * 페이지네이션
 */
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 50,
  MAX_PAGE_SIZE: 100,
} as const
